import { SearchObject } from '@app/models/search-object.model';

/**
 * Compare and swap courses that have the same course code. This is used
 * to combine and group related sibling courses, which in this case Self-Study and Instructor Led courses,
 * which the UI treats as one course.  Do not assume search results of courses are pre-sorted or in order.
 * Courses could be sorted in UI, in Docebo, or by another service.
 * @param searchObjectsMap - Search Object Map with a search item code (Docebo course code)
 * @param item - Search Object based from Docebo search results
 */
export function compareSwap(searchObjectsMap: Map<string, SearchObject>, item: SearchObject): void {
  if (searchObjectsMap && item) {
    const searchObject = searchObjectsMap.get(item.code);

    if (searchObject && searchObject.code) {
      if (searchObject.code.localeCompare(item.code) === 0) {
        const compareIndex = searchObject.name.localeCompare(item.name);

        if (compareIndex === 0) {
          // Exact Match - Do nothing. This maybe a case of a free course or course that doesn't have matching Self-study or ILT,
          // so do not update related course ids
          // console.log('CASE 0: A is LESS than', searchObject.name, searchObject.code, searchObject.id);
          // console.log('CASE 0: B is GREATER', item.name, item.code, item.id);
        } else if (compareIndex === -1) {
          // Incoming object item < previous search object, so Self-Study should be mapped to the related course id
          // console.log(
          //   'CASE -1: A is LESS than',
          //   searchObject.name,
          //   searchObject.code,
          //   searchObject.id
          // );
          // console.log('CASE -1: B is GREATER', item.name, item.code, item.id);
          searchObject.relatedCourseIds.push(item.id);
        } else {
          // Incoming object item > previous search object.
          // console.log(
          //   'CASE 1: A is GREATER than',
          //   searchObject.name,
          //   searchObject.code,
          //   searchObject.id
          // );
          // console.log('CASE 1: B is LESS', item.name, item.code, item.id);
          // Swap the item in the map with the incoming item. The key is the same but the value is different.
          searchObjectsMap.set(item.code, item);
          item.relatedCourseIds.push(searchObject.id);
        }
      }
    }
  }
}
